var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBacktotop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    transform: "rotate(-90 41 41)",
    fill: "#5795BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4142 30.4745C41.6332 29.6934 40.3668 29.6934 39.5858 30.4745L26.8579 43.2024C26.0768 43.9834 26.0768 45.2498 26.8579 46.0308C27.6389 46.8119 28.9052 46.8119 29.6863 46.0308L41 34.7171L52.3137 46.0308C53.0948 46.8119 54.3611 46.8119 55.1421 46.0308C55.9232 45.2498 55.9232 43.9834 55.1421 43.2024L42.4142 30.4745ZM43 32.6479L43 31.8887L39 31.8887L39 32.6479L43 32.6479Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktotop);
export default __webpack_public_path__ + "static/media/backtotop.64a518fff582119602dde5dea9eac757.svg";
export { ForwardRef as ReactComponent };